"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isTypeLinearS = void 0;
var isTypeLinearS = function (input) {
    if (!Array.isArray(input))
        return false;
    for (var _i = 0, input_1 = input; _i < input_1.length; _i++) {
        var element = input_1[_i];
        if (typeof element !== "string")
            return false;
    }
    return true;
};
exports.isTypeLinearS = isTypeLinearS;
//# sourceMappingURL=isTypeLinearS.js.map